module.exports = __webpack_public_path__ + "static/ecanta-google-ads-8e845cfaa4b116474ec9ba2bc362a388.png";